import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        // Only handle HTTP 401 Unauthorized errors
        // Skip auth endpoints so standard login/password failures are handled by page components
        const isAuthEndpoint = req.url.includes('/auth/') || req.url.includes('stytch.com');

        if (error.status === 401 && !isAuthEndpoint) {
          const currentUrl = router.url;
          authService.handleSessionExpired(currentUrl);
        }
      }
      return throwError(() => error);
    })
  );
};
